import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { getSchemaPaymentPlanSave } from '../../../redux/actions/paymentSave'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { getPaymentPlanSchema, getPaymentPlanData } from '../../../redux/actions/multiReview'
import ProjectDataTable from '../../../widgets/dataTable/ProjectDataTable'
import scrollToComponent from 'react-scroll-to-component'
import { Message, Panel, Row } from 'rsuite'
import BudgetSummary from '../../../widgets/budget/budgetSummary/BudgetSummary'
import BudgetPlan from '../../../widgets/budget/budgetPlan/BudgetPlan'
import { getSchemaMultiReviewSidebar } from '../../../redux/actions/sidebar'
import { useDispatch, useSelector } from 'react-redux'
import BudgetPlanMutiV2 from '../../../widgets/budget/budgetPlan/BudgetPlanMutiV2'

export default function PaymentPlanSaveMuti() {
  // const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [isReLoading, setIsReLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [proposalBudget, setProposalBudget] = useState()
  const [section, setSection] = useState()
  const [dataTableSection, setDataTableSection] = useState()
  const [singleProject, setSingleProject] = useState()
  const [singleError, setSingleError] = useState()
  const [requestBody, setRequestBody] = useState()
  const [projectList, setProjectList] = useState()
  const [projectIdList, setProjectIdList] = useState()
  const [isEditBudgetPlan, setIsEditBudgetPlan] = useState(false)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  // const isEnableEdit = isNewMultiReveiw(projectId)
  const dispatch = useDispatch()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      //let request = getRequestBody()
      let request = {
        groupId: projectId,
      }
      // console.log('handleGetSchema request', request)
      setProposalBudget('')
      setSingleProject('')
      const _schema = await getPaymentPlanSchema(request, 5, 1)
      // console.log('handleGetSchema response', _schema)
      setSchema(_schema)
      setProjectList(_schema?.forms?.projectList)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSingleSubmit = async (obj) => {
    console.log('obj', obj)
    setSingleError(false)
    startLoading()
    try {
      setProposalBudget('')
      setSingleProject(obj)
      const response = await getSchemaPaymentPlanSave(obj.id)
      console.log('response', response)

      let _schema = response?.model?.forms

      if (_schema) {
        _schema['header'] = obj.projectName
        setProposalBudget(_schema)
        setIsEditBudgetPlan(
          !_schema.ProjectBudgetPlan?.masterBudgetPlan?.value &&
            !_schema.ProjectBudgetPlan?.subBudgetPlan.value
        )
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      }
    } catch (e) {
      console.log('e', e)
      setSingleError(true)
    }

    doneLoading()
  }

  const handleReload = async (pagesize, pagenumber) => {
    setIsReLoading(true)
    startLoading()
    try {
      let request = getRequestBody()
      console.log('handleReload request', request, 'pagesize', pagesize, 'pagenumber', pagenumber)
      setProposalBudget('')
      setSingleProject('')
      const response = await getPaymentPlanData(request, pagesize, pagenumber)
      setProjectList(response)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsReLoading(false)
  }

  const onComplete = async () => {
    scrollToComponent(dataTableSection, { offset: 0, align: 'top', duration: 500 })
    // handleReload(5, 1)
    await dispatch(getSchemaMultiReviewSidebar(projectId))
    handleGetSchema()
  }

  const getRequestBody = () => {
    let request = requestBody
    if (!request) {
      let idList = sessionStorage.getItem('mutiReview')
      request = {
        id: idList,
      }
    }

    setProjectIdList(request.id.split(','))
    setRequestBody(request)
    return request
  }

  if (error) {
    return (
      <SidebarProposal isMultiReview>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isMultiReview>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isMultiReview>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      {
        //isEnableEdit &&
        schema?.forms?.projectBudgetPlan && (
          <>
            {/* {schema.forms.projectBudgetPlan.disable ? (
              <>
                <Message
                  showIcon
                  type="warning"
                  description={`เนื่องจากมีโครงการที่มีงบประมาณไม่เท่ากัน ไม่สามารถบันทึกแผนงบประมาณพร้อมกัน กรุณาบันทึกทีละโครงการจากตาราง โครงการ`}
                />
                <br />
              </>
            ) : ( */}
            <>
              <BudgetPlanMutiV2
                header={schema.forms.projectBudgetPlan.header}
                isEditable={true}
                isEdit={true}
                masterBudgetPlan={schema.forms.projectBudgetPlan?.masterBudgetPlan}
                masterBudgetValue={schema.forms.projectBudgetPlan?.masterBudgetValue}
                subBudgetPlan={schema.forms.projectBudgetPlan?.subBudgetPlan}
                subBudgetValue={schema.forms.projectBudgetPlan?.subBudgetValue}
                onComplete={onComplete}
                projectIdList={projectIdList}
                shaded={true}
                isSaveBudgetPlanStep={true}
                hideSubPlan
              />
              <br />
            </>
            {/* )} */}
          </>
        )
      }

      <Row
        ref={(section) => {
          setDataTableSection(section)
        }}
      ></Row>

      {projectList && (
        <>
          <ProjectDataTable
            schema={projectList}
            single={{
              enable: true,
              buttonText: 'บันทึกแผนงบประมาณ',
              iconByStatus: true,
              hideText: false,
              width: 210,
            }}
            onSingleSubmit={onSingleSubmit}
            pagination={true}
            onReload={handleReload}
            loading={isReLoading}
          />
          <br />
        </>
      )}

      <Row
        ref={(section) => {
          setSection(section)
        }}
      >
        {singleError && (
          <>
            <Message
              showIcon
              type="error"
              description={`ดึงข้อมูลโครงการ ${singleProject?.projectName} ไม่สำเร็จ`}
            />
            <br />
          </>
        )}
      </Row>

      {proposalBudget && (
        <Panel
          header={proposalBudget.header}
          bordered
          collapsible
          defaultExpanded
          shaded
          style={{ marginBottom: 20 }}
        >
          {proposalBudget.ProjectBudgetInfo && (
            <div style={{ marginBottom: 10 }}>
              <BudgetSummary
                header={proposalBudget.ProjectBudgetInfo.header}
                budget={proposalBudget.ProjectBudgetInfo.budget}
                duration={proposalBudget.ProjectBudgetInfo.duration}
              />
            </div>
          )}

          {/* {console.log('proposalBudget => ', proposalBudget.ProjectBudgetPlan?.skipReserveEbudget)} */}
          <div style={{ marginBottom: 10 }}>
            <BudgetPlan
              header={proposalBudget.ProjectBudgetPlan.header}
              isEditable={true}
              isEdit={isEditBudgetPlan}
              masterBudgetPlan={proposalBudget.ProjectBudgetPlan?.masterBudgetPlan}
              masterBudgetValue={proposalBudget.ProjectBudgetPlan?.masterBudgetValue}
              skipReserveEbudget={proposalBudget.ProjectBudgetPlan?.skipReserveEbudget}
              subBudgetPlan={proposalBudget.ProjectBudgetPlan?.subBudgetPlan}
              subBudgetValue={proposalBudget.ProjectBudgetPlan?.subBudgetValue}
              isSaveBudgetPlanStep={true}
              onComplete={onComplete}
              projectVersionId={singleProject.id}
              setIsEdit={() => {
                setIsEditBudgetPlan(!isEditBudgetPlan)
              }}
              hideSubPlan
            />
          </div>
        </Panel>
      )}
    </SidebarProposal>
  )
}

// const mockSchema = {
//   header: 'บันทึกแผนงบประมาณ (หลายโครงการ)',
//   subHeader: '',
//   forms: {
//     projectBudgetPlan: {
//       header: 'ระบุแผน',
//       buttonBudgetPlanSaveLabel: 'บันทึก',
//       masterBudgetPlan: {
//         label: 'แผนหลัก',
//         value: '',
//         text: 'กลุ่มแผนงานด้านการพัฒนานโยบายสาธารณะและการบังคับใช้กฎหมาย',
//         items: [
//           {
//             label: 'แผนควบคุมยาสูบ',
//             value: 'F55E1894-ABE1-4B29-9E8E-C77D7C7CEE91',
//             isSelected: false,
//             children: [
//               {
//                 label: 'กลุ่มแผนงานด้านการพัฒนานโยบายสาธารณะและการบังคับใช้กฎหมาย ',
//                 value: '051869BD-9649-4237-BC1E-781EA15E495B',
//                 isSelected: true,
//                 children: null,
//               },
//               {
//                 label: 'กลุ่มแผนงานด้านการพัฒนาวิชาการและระบบข้อมูลข่าวสาร',
//                 value: '81E5F130-F83C-4A13-A0E0-BE4007916D3F',
//                 isSelected: false,
//                 children: null,
//               },
//               {
//                 label:
//                   'กลุ่มแผนงานด้านการพัฒนาเครือข่าย การรณรงค์ประชาสัมพันธ์ และการขยายสถานที่ปลอดบุหรี่ ',
//                 value: 'D36E127E-6EB0-4425-ACE2-B44FDED79F2D',
//                 isSelected: false,
//                 children: null,
//               },
//               {
//                 label: 'กลุ่มแผนงานสนับสนุนบริการบำบัดรักษาการติดนิโคติน ',
//                 value: '50E420FD-C0D5-4865-AE7D-A0E531C6F263',
//                 isSelected: false,
//                 children: null,
//               },
//               {
//                 label: 'การพัฒนาและบริหารงานสร้างเสริมสุขภาพ',
//                 value: 'CEC5C895-EDA7-47B0-95B9-0C13599BB524',
//                 isSelected: false,
//                 children: [
//                   {
//                     label: 'บริหารจัดการ',
//                     value: 'B68FB538-86AB-4209-B7F7-95D8E1979FEF',
//                     isSelected: false,
//                     children: null,
//                   },
//                 ],
//               },
//             ],
//           },
//         ],
//         validators: [
//           {
//             type: 'REQUIRED',
//             errorMessage: 'กรุณาเลือกแผนหลัก',
//           },
//         ],
//       },
//       subBudgetPlan: {
//         label: 'แผนรอง',
//         value: '',
//         text: 'กลุ่มแผนงานด้านการพัฒนาเครือข่าย การรณรงค์ประชาสัมพันธ์ และการขยายสถานที่ปลอดบุหรี่',
//         items: [
//           {
//             label: 'แผนควบคุมยาสูบ',
//             value: 'F55E1894-ABE1-4B29-9E8E-C77D7C7CEE91',
//             isSelected: false,
//             children: [
//               {
//                 label: 'กลุ่มแผนงานด้านการพัฒนานโยบายสาธารณะและการบังคับใช้กฎหมาย ',
//                 value: '051869BD-9649-4237-BC1E-781EA15E495B',
//                 isSelected: false,
//                 children: null,
//               },
//               {
//                 label: 'กลุ่มแผนงานด้านการพัฒนาวิชาการและระบบข้อมูลข่าวสาร',
//                 value: '81E5F130-F83C-4A13-A0E0-BE4007916D3F',
//                 isSelected: false,
//                 children: null,
//               },
//               {
//                 label:
//                   'กลุ่มแผนงานด้านการพัฒนาเครือข่าย การรณรงค์ประชาสัมพันธ์ และการขยายสถานที่ปลอดบุหรี่ ',
//                 value: 'D36E127E-6EB0-4425-ACE2-B44FDED79F2D',
//                 isSelected: true,
//                 children: null,
//               },
//               {
//                 label: 'กลุ่มแผนงานสนับสนุนบริการบำบัดรักษาการติดนิโคติน ',
//                 value: '50E420FD-C0D5-4865-AE7D-A0E531C6F263',
//                 isSelected: false,
//                 children: null,
//               },
//               {
//                 label: 'การพัฒนาและบริหารงานสร้างเสริมสุขภาพ',
//                 value: 'CEC5C895-EDA7-47B0-95B9-0C13599BB524',
//                 isSelected: false,
//                 children: [
//                   {
//                     label: 'บริหารจัดการ',
//                     value: 'B68FB538-86AB-4209-B7F7-95D8E1979FEF',
//                     isSelected: false,
//                     children: null,
//                   },
//                 ],
//               },
//             ],
//           },
//           {
//             label: 'แผนควบคุมเครื่องดื่มแอลกอฮอล์และสิ่งเสพติด',
//             value: '4E21ADFB-EC91-4562-8F97-44CDBEA2479D',
//             isSelected: false,
//             children: [
//               {
//                 label:
//                   'กลุ่มแผนงานพัฒนานโยบายสาธารณะและการบังคับใช้กฎหมายเพื่อการควบคุมการบริโภคเครื่องดื่มแอลกอฮอล์',
//                 value: '426285AA-30C1-4BE6-AFE1-AA2C697F42F6',
//                 isSelected: false,
//                 children: null,
//               },
//               {
//                 label:
//                   'กลุ่มแผนการพัฒนาวิชาการและระบบข้อมูลข่าวสารเพื่อการควบคุมการบริโภคเครื่องดื่มแอลกอฮอล์',
//                 value: '5F121861-63EA-4D92-9C63-9C15CBFD1864',
//                 isSelected: false,
//                 children: null,
//               },
//               {
//                 label:
//                   'กลุ่มแผนการพัฒนาเครือข่ายและการรณรงค์ประชาสัมพันธ์เพื่อการควบคุมการบริโภคเครื่องดื่มแอลกอฮอล์',
//                 value: 'B23F8017-605D-4BC4-90F3-E5E0EEC7C01C',
//                 isSelected: false,
//                 children: null,
//               },
//               {
//                 label: 'กลุ่มแผนการพัฒนารูปแบบและระบบบริการเลิกสุรา',
//                 value: '5B5641F5-3302-475B-880A-281D47B49961',
//                 isSelected: false,
//                 children: null,
//               },
//               {
//                 label: 'กลุ่มแผนสนับสนุนการป้องกันและแก้ไขปัญหายาเสพติด',
//                 value: 'D1890788-F92E-43D4-9026-A746AA4966AF',
//                 isSelected: false,
//                 children: null,
//               },
//               {
//                 label: 'การพัฒนาและบริหารงานสร้างเสริมสุขภาพ',
//                 value: '826ED127-F83D-493E-B513-DF6CA2092A25',
//                 isSelected: false,
//                 children: null,
//               },
//             ],
//           },
//         ],
//         validators: [
//           {
//             type: 'REQUIRED',
//             errorMessage: 'กรุณาเลือกแผนรอง',
//           },
//         ],
//       },
//     },
//     projectList: {
//       header: 'โครงการ',
//       projectCodeText: 'รหัสโครงการหลัก',
//       projectNameText: 'ชื่อโครงการหลัก',
//       projectTypeText: 'ประเภทโครงการ',
//       projectBudgetText: 'งบประมาณรวม',
//       buttonText: 'บันทึกแผนงบประมาณ',
//       message: {
//         type: 'warning',
//         message: 'งบประมาณที่ขอไม่สอดคล้องกับแผนการจัดสรรงบประมาณของ สสส.',
//       },
//       totalSize: 3,
//       values: [
//         {
//           id: '42E5F48A-154A-4942-A08C-E0A9FD659511',
//           projectCode: '60-001000',
//           projectName: 'การจัดการขยะในชุมชน',
//           projectBudget: 5444273.5,
//           projectType: {
//             value: '3',
//             name: 'แผนงาน',
//           },
//           projectStatus: 0,
//         },
//         {
//           id: 'F08C927F-2F81-40A8-B673-3DE67648C379',
//           projectCode: '60-001002',
//           projectName: 'ลด ละ เลิก การดื่มแอลกอฮอล์ในชุมชน',
//           projectBudget: 5009724,
//           projectType: {
//             value: '2',
//             name: 'ชุดโครงการ',
//           },
//           projectStatus: 1,
//         },
//         {
//           id: '1A5025C6-9997-4B22-862F-159DD56EE11E',
//           projectCode: '60-001004',
//           projectName: 'การจัดการจุดเสี่ยงเพื่อป้องกันอุบัติเหตุทางถนนในชุมชน',
//           projectBudget: 9530940,
//           projectType: {
//             value: '1',
//             name: 'โครงการ',
//           },
//           projectStatus: 2,
//         },
//       ],
//     },
//   },
// }
